var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"el-zoom-in-top","mode":"out-in"}},[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(_vm.$route.meta.keepAlive)?_c('Layout'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }